import { render } from "./oncology_diagnosis.vue?vue&type=template&id=11e7516f&scoped=true"
import script from "./oncology_diagnosis.vue?vue&type=script&lang=js"
export * from "./oncology_diagnosis.vue?vue&type=script&lang=js"

import "./oncology_diagnosis.vue?vue&type=style&index=0&id=11e7516f&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e7516f"]])

export default __exports__